var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0625 17.8947H15.9375C16.2193 17.8947 16.4895 18.0056 16.6888 18.203C16.8881 18.4005 17 18.6682 17 18.9474C17 19.2265 16.8881 19.4943 16.6888 19.6917C16.4895 19.8891 16.2193 20 15.9375 20H1.0625C0.780707 20 0.510457 19.8891 0.311199 19.6917C0.111942 19.4943 0 19.2265 0 18.9474C0 18.6682 0.111942 18.4005 0.311199 18.203C0.510457 18.0056 0.780707 17.8947 1.0625 17.8947ZM9.5625 11.7632L13.0082 8.35053L14.5106 9.83895L8.5 15.7937L2.48944 9.83895L3.99181 8.35053L7.4375 11.7632V0H9.5625V11.7632Z",
    fill: "#BCC5D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.06ccea5db9ceee251f4039ac2611dc17.svg";
export { ForwardRef as ReactComponent };